<template>
  <v-hover>
    <base-card
      slot-scope="{ hover }"
      color="secondary"
      :class="{'elevation-12 scale-down' : hover}"
      :to="{ name: 'artist.single', params: { artistSlug: artist.slug }}"
    >
      <tk-media
        contain
        min-height="50px"
        position="top center"
        sizes="350px"
        lazy-src="/static/img/placeholder.png"
        :media="artist.getArtistMedia()"
        :style="{'background-color': artist.getArtistMedia().color }"
      >
        <div class="text-xs-right">
          <v-icon class="video-icon" v-if="artist.video" v-text="'fas fa-video'" />
          <span v-if="artist.hasCV" class="v-icon cv">CV</span>
        </div>
      </tk-media>
      <v-card-title class="pa-2">{{ artist.name }}</v-card-title>

      <slot name="action-btns"></slot>
    </base-card>
  </v-hover>
</template>

<script>
import { Artist } from '../../../../services/artist/Artist'

export default {
  name: 'ArtistCard',
  props: {
    artist: {
      type: Artist,
      required: true
    },
  },
}
</script>

<style scoped>

</style>
